import find from 'lodash/find'
import first from 'lodash/first'
import React, { FC } from 'react'

import { GenericAttributeRendererProps, GenericTextAttributeRenderer } from '@Components/Product/GenericTextAttributeRenderer'
import { BaseAttribute } from '@Generated/graphql'
import { useLocale } from '@Globals/Locale'
import { useTranslation } from '@Globals/Translations'

type DimensionsProps = Pick<GenericAttributeRendererProps, 'asSection' | 'includeHeader' | 'product' | 'selectedVariantID'>

export const ProductDimensions: FC<DimensionsProps> = (props) => {
  const { product, selectedVariantID } = props
  const locale = useLocale()
  const { t } = useTranslation()

  // TH-2120: We don't want dimensionsText for Gloves as they are a part of size guide
  if (product?.type === 'gloves') {
    return null
  }

  const currentVariantData = (selectedVariantID && find(product?.variants, ['id', selectedVariantID])) || product?.masterVariant
  const sizeLabel = ((find(currentVariantData?.attributes, ['key', 'computerSizes']) as BaseAttribute)?.value || [])
  const labelToPrint = first(sizeLabel as Record<string, any>[])?.label[locale]

  const computerSizeData = labelToPrint
    ? <div style={{ marginTop: '20px' }}>{t('products:PP_HOLDS_UP_TO_X_LAPTOPS', 'Holds up to {{arg1}} laptops', { arg1: labelToPrint })}</div>
    : null

  return (
    <GenericTextAttributeRenderer {...props} attributeKeyName="dimensionsText" header="products:PP_DIMENSIONS_TITLE">
      {computerSizeData}
    </GenericTextAttributeRenderer>
  )
}
